class NetworkError extends Error {}

export default NetworkError;
